/**
 * Mini-utility audio per Bolletto. Usa la Web Audio API (no file, no dipendenze, no CORS).
 *
 * Esposta `playReadyDing()` — suono "analisi pronta": due note ascendenti A5 → E6,
 * volume basso (0.15), durata totale ~250ms. Non invadente.
 *
 * Nota: i browser bloccano audio prima del primo user-gesture. Poiché la funzione
 * viene chiamata dentro un handler di click (apertura analisi), funziona sempre.
 */

let _ctx = null;

function _getContext() {
  if (_ctx) return _ctx;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  try {
    _ctx = new Ctx();
    return _ctx;
  } catch {
    return null;
  }
}

function _beep(ctx, freq, startTime, duration, gain = 0.10, type = 'sine') {
  const osc = ctx.createOscillator();
  const env = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  // Envelope: attack rapido + decay esponenziale → suono "campanella"
  env.gain.setValueAtTime(0, startTime);
  env.gain.linearRampToValueAtTime(gain, startTime + 0.015);
  env.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
  osc.connect(env);
  env.connect(ctx.destination);
  osc.start(startTime);
  osc.stop(startTime + duration + 0.05);
}

/**
 * Suono "analisi pronta": singola nota A5 (880 Hz) breve con envelope esponenziale.
 * Disattivabile dall'utente via localStorage('bolletto_sound_off' = '1').
 */
export function playReadyDing() {
  if (typeof window === 'undefined') return;
  if (window.localStorage?.getItem('bolletto_sound_off') === '1') return;
  const ctx = _getContext();
  if (!ctx) return;
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  const now = ctx.currentTime;
  _beep(ctx, 880, now, 0.18, 0.15); // A5, ~180ms decay
}

/** Disattiva i suoni di notifica per questo browser. */
export function disableSound() {
  try { window.localStorage?.setItem('bolletto_sound_off', '1'); } catch {/* ignore */}
}

/** Riattiva i suoni di notifica. */
export function enableSound() {
  try { window.localStorage?.removeItem('bolletto_sound_off'); } catch {/* ignore */}
}

/** True se i suoni sono attivi (default). */
export function isSoundEnabled() {
  try { return window.localStorage?.getItem('bolletto_sound_off') !== '1'; }
  catch { return true; }
}
